import { useEffect } from 'react';
import { getRecaptchaV3SiteKey, initializeRecaptchaV3Badge } from '../utils/recaptchaV3';

const BADGE_STYLE_ID = 'appgallop-recaptcha-v3-badge-style';

export function RecaptchaV3Badge() {
  useEffect(() => {
    if (!getRecaptchaV3SiteKey()) {
      console.warn('Google reCAPTCHA v3 badge is disabled because VITE_RECAPTCHA_V3_SITE_KEY is not configured.');
      return;
    }

    if (!document.getElementById(BADGE_STYLE_ID)) {
      const style = document.createElement('style');
      style.id = BADGE_STYLE_ID;
      style.textContent = `
        /* Collapsed by default — logo icon only */
        .grecaptcha-badge {
          position: fixed !important;
          left: 12px !important;
          right: auto !important;
          bottom: 12px !important;
          z-index: 2147483647 !important;
          visibility: visible !important;
          opacity: 1 !important;
          overflow: hidden !important;
          width: 60px !important;
          transition: width 0.3s ease !important;
        }

        /* Expanded on hover — full badge with blue panel */
        .grecaptcha-badge:hover {
          width: 256px !important;
        }

        @media (max-width: 640px) {
          .grecaptcha-badge {
            bottom: 88px !important;
            transform: scale(0.86);
            transform-origin: left bottom;
          }
        }
      `;
      document.head.appendChild(style);
    }

    initializeRecaptchaV3Badge().catch((error) => {
      console.warn('Google reCAPTCHA v3 badge could not be initialized:', error);
    });
  }, []);

  return null;
}
